module.exports = __webpack_public_path__ + "40fd667467ac9128ceb9d8b40cd41c07.svg";